// Phase: .pen redesign — 旧 /sub-agents 路由保留，重定向到设计稿新名 /sub-agent-settings
import { Navigate } from 'react-router-dom'

export function AgentSubAgentsPage() {
  return <Navigate to="/sub-agent-settings" replace />
}
